export var createMuiTableSortLabelOverrides = function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            // Using overly specific selectors to match MUI implementation
            "&:focus": {
                color: undefined,
            },
            "&.Mui-focusVisible": {
                color: palette.text.primary,
            },
            "&:hover": {
                color: palette.text.primary,
                "& $icon": {
                    opacity: 1,
                },
            },
            "&$active": {
                color: undefined,
                "&& $icon": {
                    color: palette.text.secondary,
                },
            },
        },
        icon: {
            fontSize: 16, // Not `rem` because it controls the icons size, not text
        },
    });
};
//# sourceMappingURL=MuiTableSortLabel.js.map